export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN'
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
export const CLEAR_TOKENS = 'CLEAR_TOKENS'
export const TOKEN_CHECKED = 'TOKEN_CHECKED'
